import { AbstractModel } from '@patsnap/tahiti-core';
import type { RetrievalProgressStateV2 } from '../retrieval-progress-model-v2';
import type { RetrievalProgressModelV2 } from '../retrieval-progress-model-v2';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export function createInitialRetrievalProgressStateV2(): RetrievalProgressStateV2 {
    return {
        process_dict_keys: [],
        process_dict: {},
        task_cost: 0,
        task_id: '',
        task_status: 'running',
        cc_docs_num: 0,
        excute_times: 0,
        update_ts: '',
    };
}

@injectable()
export class RetrievalProgressModelV2Impl extends AbstractModel<RetrievalProgressStateV2> implements RetrievalProgressModelV2 {
    protected _modelData: RetrievalProgressStateV2 = createInitialRetrievalProgressStateV2();

    dispose(): void {
        this.update(() => createInitialRetrievalProgressStateV2());
    }
}

